import { Identifiable, Status, markTaskAsCompletedError } from "@planzone/dto";
import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function getCompletedStatus(
  statuses: Identifiable<Status>[],
): Promise<Identifiable<Status>> {
  const status = statuses.find(
    (status) => status.percentComplete === 100 && status.basic,
  );

  return status
    ? Promise.resolve(status)
    : Promise.reject({
        completedStatusNotFound: true,
      });
}

function createInteractor(repository: Repository): Interactor {
  return ({ project, task, completionDate }) =>
    present(
      repository
        .getTaskStatuses(project)
        .then(getCompletedStatus)
        .then((status) =>
          repository
            .editTask(task, {
              ...task,
              status,
              percentComplete: 100,
              completionDate,
            })
            .then(({ impactedElements }) => ({
              ...task,
              impactedElements,
              status,
              percentComplete: 100,
              completionDate,
            })),
        )

        .then(({ impactedElements, ...nextTask }) => ({
          project,
          task: nextTask,
          impactedElements,
          completionDate,
        }))
        .catch((e) =>
          Promise.reject({
            error: { ...markTaskAsCompletedError, ...e },
            project,
            task,
            completionDate,
          }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
